import React, { useState } from "react"
import { Row, Col, Button, Container, Modal, Form } from "react-bootstrap"
import { useDispatch } from "react-redux"
import { LeadForm } from "../../components/lead/LeadForm"
import { toggleModelBox } from "../../systemSlice"
import DefaultLayout from "../../components/layout/DefaultLayout"
import { LeadTable } from "../../components/lead/LeadTable"
import { addStageAction } from "./stageAction"

const Leads = () => {
  const dispatch = useDispatch()
  const [showForm, setShowForm] = useState(false)
  const [showStageForm, setShowStageForm] = useState(false)
  const [stageName, setStageName] = useState("")

  const handleOnShowForm = () => {
    setShowForm(true)
    dispatch(toggleModelBox())
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    if (!stageName) return
    dispatch(addStageAction({ name: stageName }))
    setStageName("")
    setShowStageForm(false)
  }

  return (
    <DefaultLayout>
      {showForm && <LeadForm setShowForm={setShowForm} />}
      {showStageForm && (
        <Modal show={showStageForm} onHide={() => setShowStageForm(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Add Stage</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form className="d-flex flex-column" onSubmit={handleSubmit}>
              <Form.Group>
                <Form.Label>Stage Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter stage name"
                  onChange={(e) => setStageName(e.target.value)}
                  name="stage"
                />
              </Form.Group>

              <Button
                type="submit"
                variant="secondary"
                className="ms-auto mt-2"
              >
                Add
              </Button>
            </Form>
          </Modal.Body>
        </Modal>
      )}
      <Container>
        <Row className="py-2">
          <Col>
            <h5>Client Leads</h5>
            <div className="text-end">
              <Button
                variant="secondary"
                className="mx-2"
                onClick={() => setShowStageForm(true)}
              >
                Add Stage
              </Button>
              <Button variant="primary" onClick={handleOnShowForm}>
                Add New Student Lead
              </Button>
            </div>
            <hr />
          </Col>
        </Row>
        <Row>
          <Col>
            <LeadTable />
          </Col>
        </Row>
      </Container>
    </DefaultLayout>
  )
}

export default Leads
